var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('v-img',{attrs:{"height":"40","width":"40","src":_vm.url}}):_c('v-btn',{attrs:{"depressed":""}},[_c('v-icon',{staticClass:"pa-0",attrs:{"small":"","color":"grey"}},[_vm._v("mdi-folder-image")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }